/* eslint-disable react/require-default-props */
import React from 'react';
import { translate } from '@utils/i18n';
import InlineSelect from '../Select';
import DropDownSelect from '../../Select/Select';
import useGetExternalEntities from './useGetExternalEntities';
import Loader, { LoaderSizes } from '../Loader';
export default function ExternalEntitySelector({ id, className, value, onChange, url, fieldMapping = { idField: 'value', nameField: 'label' }, placeholderText = translate('select_an_option', { namespace: 'features.commons' }), errorText = translate('options_error', { namespace: 'features.commons' }), allowClear = true, showSearch = false, searchPlaceholder = translate('search_options', { namespace: 'features.commons' }), maxHeight, variant = 'inline', label = '', disabled = false }) {
    const { data: entities = [], isFetching, error } = useGetExternalEntities(url, fieldMapping);
    // Transform entities into Select options
    const options = entities.map((entity) => ({
        value: entity.id.toString(),
        label: entity.name
    }));
    // Conditionally add empty option for clearing selection based on allowClear prop
    const allOptions = allowClear || !value ? [{ value: '', label: placeholderText }, ...options] : options;
    const handleChange = (selectedValue) => {
        if (!selectedValue) {
            onChange(null);
            return;
        }
        const selectedEntity = entities.find((entity) => entity.id.toString() === selectedValue);
        onChange(selectedEntity || null);
    };
    if (isFetching) {
        return (React.createElement("div", { className: className },
            React.createElement(Loader, { size: LoaderSizes.small })));
    }
    if (error) {
        return (React.createElement("div", { className: className },
            React.createElement("span", null, errorText)));
    }
    if (variant === 'dropdown') {
        return (React.createElement(DropDownSelect, { id: id, className: className, options: options, value: value || '', label: label, onChange: (e) => {
                handleChange(e.target.value);
            }, showSearch: showSearch, searchPlaceholder: searchPlaceholder, maxHeight: maxHeight, disabled: disabled || isFetching || !entities.length || !url }));
    }
    return (React.createElement(InlineSelect, { id: id, className: className, options: allOptions, value: value || '', onChange: handleChange, showSearch: showSearch, searchPlaceholder: searchPlaceholder, maxHeight: maxHeight, disabled: disabled || isFetching || !entities.length || !url }));
}
